/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuthStore } from '../store/authStore';
import { finishLogin } from '../utils/ssoReturn';

export default function SSOCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { ssoLogin } = useAuthStore();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    if (!code || !state) {
      toast.error('Missing SSO response parameters');
      navigate('/login');
      return;
    }
    ssoLogin(code, state)
      .then(() => {
        // finishLogin resumes a pending invitation acceptance first, then
        // honors the cross-portal hand-off (sessionStorage.sso_return,
        // allowlisted targets only), falling back to navigate('/').
        finishLogin(navigate);
      })
      .catch(() => {
        toast.error('SSO sign-in failed. Please try again.');
        navigate('/login');
      });
  }, [searchParams, ssoLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-gray-500">Completing sign-in…</div>
    </div>
  );
}
